import React, { useState, useEffect, useContext } from "react";
import { withRouter, Link, useHistory } from "react-router-dom";
import classNames from "classnames";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import { Paper, MenuItem, MenuList, Drawer, Hidden, IconButton, Toolbar, AppBar } from "@material-ui/core";
import { Menu } from "@material-ui/icons";
import styles from "./../assets/style/headerStyle";
import logo from "../assets/images/logo.png"
import ButtonZ from "../components/CustomButtons/Button"
import { AppContext } from "../contexts/appContext";
import { Notifications, NotificationImportant } from "@material-ui/icons";
import { notificationAPI } from "../services/NotificationService";

const useStyles = makeStyles(styles);

const Header = (props) => {
    let history = useHistory()
    const classes = useStyles();
    const { notifications_ref, notifications, setNotifications, setPage } = useContext(AppContext)
    const [width, setWidth] = useState(window.innerWidth)
    const [mobileOpen, setMobileOpen] = useState(false);
    const [fontColor, setFontColor] = useState("white")
    const [dropdown, setDropDown] = useState(false)
    useEffect(() => {
        if (props.changeColorOnScroll) {
            window.addEventListener("scroll", headerColorChange);
        }
        window.addEventListener("resize", headerSizeChange)
        return function cleanup() {
            if (props.changeColorOnScroll) {
                window.removeEventListener("scroll", headerColorChange);
            }
            window.removeEventListener("resize", headerSizeChange)
        };
    });
    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const headerSizeChange = () => {
        setWidth(window.innerWidth)
    }

    const headerColorChange = () => {
        const { changeColorOnScroll } = props;
        const windowsScrollTop = window.pageYOffset;
        if (windowsScrollTop > changeColorOnScroll.height) {
            document.body
                .getElementsByTagName("header")[0]
                ?.classList.remove("makeStyles-com7-01");
            document.body
                .getElementsByTagName("header")[0]
                ?.classList.add(classes[changeColorOnScroll.color]);
            setFontColor("black")
        } else {
            document.body
                .getElementsByTagName("header")[0]
                ?.classList.add("makeStyles-com7-01");
            document.body
                .getElementsByTagName("header")[0]
                ?.classList.remove(classes[changeColorOnScroll.color]);
            setFontColor("white")
        }
    };
    const { rightLinks, leftLinks, brand, fixed, absolute } = props;
    const appBarClasses = classNames({
        [classes.appBar]: true,
        [classes['com7']]: 'com7',
        [classes.absolute]: absolute,
        [classes.fixed]: fixed,
    });

    const brandComponent = <Link className="aareza" to="/" >
        <img src={logo} style={{ display: 'inline-block' }} width="91px" height="30px" />
        {width >= 495 && <span className={classes.title} style={{ height: '30px' }}>{brand}</span>}
    </Link>;

    const beforePush = (res) => {
        if (!res.is_read) {
            notificationAPI.readNotification(res._id)
                .then((rez) => {
                    if (rez.status == 200) {
                        let array_dummy = [...notifications]
                        let index = array_dummy.findIndex((ref) => ref._id == res._id)
                        if (index >= 0) {
                            array_dummy[index].is_read = true
                        }
                        setNotifications(array_dummy)
                    }
                })
        }
        history.push(res.push_to)
    }

    const handleScroll = (e) => {
        const bottom = e.target.scrollHeight - e.target.scrollTop == e.target.clientHeight;
        if (bottom && notifications_ref.current == 10) {
            setPage((old) => old + 1)
        }
    }

    return (
        <AppBar className={`${appBarClasses} makeStyles-com7-01`} style={{ color: fontColor }}>
            <Toolbar className={classes.container}>
                {leftLinks !== undefined ? brandComponent : null}
                {leftLinks !== undefined ? (
                    <Hidden smDown implementation="css">
                        {leftLinks}
                    </Hidden>
                ) : (
                    brandComponent
                )}
                <div style={{ marginLeft: 'auto' }} onMouseEnter={() => setDropDown(true)} onMouseLeave={() => setDropDown(false)}>
                    <ButtonZ
                        style={{ padding: '0px' }}
                        color="transparent"
                        className={classes.navLink}
                    >
                        {notifications.filter((res) => !res.is_read).length == 0 ? <Notifications className={classes.icons} style={{ width: '20px', height: '20px', marginRight: '0px', marginLeft: '3px' }} />
                            : <NotificationImportant className={classes.icons} style={{ width: '20px', height: '20px', marginRight: '0px', marginLeft: '3px' }} />}
                        {notifications.filter((res) => !res.is_read).length >= 1 && notifications.filter((res) => !res.is_read).length}
                    </ButtonZ>
                    {dropdown && <Paper onScroll={handleScroll} className={classes.dropdown} style={{ position: 'absolute', zIndex: 2022, height: notifications.length >= 7 ? '25vh' : 'auto', overflowY: 'auto' }}><MenuList role="menu" style={{ padding: '0px', overflowY: 'auto' }}>
                        {notifications.map((res, key) => {
                            return (
                                <MenuItem
                                    key={key}
                                    onClick={() => beforePush(res)}
                                    className={res.is_read ? "notification_read" : "notification_noread"}
                                >
                                    {res.title}
                                </MenuItem>
                            )
                        })}
                    </MenuList></Paper>}
                </div>
                <Hidden smDown implementation="css">
                    {rightLinks}
                </Hidden>
                <Hidden mdUp>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerToggle}
                    >
                        <Menu />
                    </IconButton>
                </Hidden>
            </Toolbar>
            <Hidden mdUp implementation="js">
                <Drawer
                    variant="temporary"
                    anchor={"right"}
                    open={mobileOpen}
                    classes={{
                        paper: classes.drawerPaper,
                    }}
                    onClose={handleDrawerToggle}
                >
                    <div className={classes.appResponsive}>
                        {leftLinks}
                        {rightLinks}
                    </div>
                </Drawer>
            </Hidden>
        </AppBar >
    );
}

export default withRouter(Header)

Header.defaultProp = {
    color: "rose",
};

Header.propTypes = {
    color: PropTypes.oneOf([
        "primary",
        "info",
        "success",
        "warning",
        "danger",
        "transparent",//สีตามพื้นหลัง
        "white",
        "rose",
        "dark",
    ]),
    rightLinks: PropTypes.node,
    leftLinks: PropTypes.node,
    brand: PropTypes.string,
    fixed: PropTypes.bool,
    absolute: PropTypes.bool,
    changeColorOnScroll: PropTypes.shape({
        height: PropTypes.number.isRequired,
        color: PropTypes.oneOf([
            "primary",
            "info",
            "success",
            "warning",
            "danger",
            "transparent",
            "white",
            "rose",
            "dark",
        ]).isRequired,
    }),
};
